export default {"src":"/_next/static/media/FirstHolderNFT.aeb97f66.gif","height":480,"width":512,"blurWidth":0,"blurHeight":0};